import { getEnv } from './envConfig'
let env = getEnv()

export const ENDPOINT = env.ENDPOINT
export const KEYCLOAK_URL = env.KEYCLOAK_URL



export const USERS = '/api/v1/users';
export const ROLES = '/api/v1/roles';
export const DESIGNATIONS = '/api/v1/designations';
export const ROLES_DATA_SETUP = '/api/v1/roles';
export const MEMBERSHIP_TYPES = '/api/v1/membership-types';
export const USERS_DATA_SETUP = '/api/v1/users';
export const COMMITTEES = '/api/v1/committees';
export const COMMITTEE_TYPES = '/api/v1/committee-types';
export const COMMITTEE_MEMBERSHIPS = '/api/v1/committee-memberships';
export const DOCUMENTS = '/api/v1/documents';
export const DOCUMENT_VERSIONS = '/api/v1/document-versions';
export const DOCUMENT_VERSION_REVIEWERS = '/api/v1/document-version-reviewers';
export const DOCUMENT_SECTIONS = '/api/v1/document-sections';
export const DOCUMENT_EDITS = '/api/v1/document-edits';
export const FINAL_DOCUMENTS = '/api/v1/final-documents';
export const NATIONAL_POSITION_DOCUMENTS = '/api/v1/national-position-documents';
export const COMMENT_CATEGORIES = '/api/v1/comment-categories';
export const TECHNICAL_EXPERTISE = '/api/v1/technical-expertise';
export const DOCUMENT_TYPES = '/api/v1/document-types';
export const COMMENTS = '/api/v1/comments';
export const NOTIFICATIONS = '/api/v1/notifications';
export const DOCUMENTS_UPLOAD = '/api/v1/documents/upload';
export const FILE_DOWNLOAD = ENDPOINT + '/api/file';
export const WORKFLOW_TYPES = ENDPOINT + '/api/v1/workflow-types';
export const WORKFLOW_DEFINITIONS = ENDPOINT + '/api/v1/workflow-definitions';
export const WORKFLOW_STEPS = ENDPOINT + '/api/v1/workflow-steps';
export const WORKFLOW_TRANSITIONS = ENDPOINT + '/api/v1/workflow-transitions';
export const WORKFLOW_TRANSITION_ROLES = ENDPOINT + '/api/v1/workflow-transition-roles';
export const WORKFLOW_ACTIONS_AVAILABLE = ENDPOINT + '/api/v1/workflow/actions/available';
export const WORKFLOW_ACTIONS_RESOLVE = ENDPOINT + '/api/v1/workflow/actions/resolve';
export const WORKFLOW_TRANSITIONS_EXECUTE = ENDPOINT + '/api/v1/workflow/transitions/execute';
export const WORKFLOW_INSTANCES = ENDPOINT + '/api/v1/workflow-instances';
export const WORKFLOW_TASKS = ENDPOINT + '/api/v1/workflow-tasks';
export const WORKFLOW_DECISIONS = ENDPOINT + '/api/v1/workflow-decisions';
export const WORKFLOW_EVENTS = ENDPOINT + '/api/v1/workflow-events';
export const CHATS = '/api/v1/chats';
export const DASHBOARD = '/api/v1/dashboard';
export const REPORTS = '/api/v1/reports';
export const AUDIT_LOGS = '/api/v1/audit-logs';
export const AUTH_FORGOT_PASSWORD = '/api/v1/auth/forgot-password';

